import { useQuery } from "@tanstack/react-query";
import type { ProductList } from "@nh/shared";
import { fetchShopProducts, shopProductsQueryKey } from "./shop.api";

/**
 * El catálogo público.
 *
 * La política de reintentos vive en el `QueryClient` (`app/providers.tsx`)
 * y no aquí: así una prueba puede apagarla y la pantalla no se queda en
 * "cargando" mientras reintenta contra un backend que no existe.
 */
export function useShopProducts() {
  return useQuery<ProductList>({
    queryKey: shopProductsQueryKey,
    queryFn: fetchShopProducts,
  });
}
